
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career/[academy]",
      function () {
        return require("private-next-pages/career/[academy].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career/[academy]"])
      });
    }
  